import React from "react";
import { motion } from "framer-motion";
import {
  Mail,
  Phone,
  MapPin,
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[linear-gradient(180deg,#fdfbff_0%,#f3efff_45%,#f8f5ff_100%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_12%_18%,rgba(99,102,241,0.10),transparent_22%),radial-gradient(circle_at_88%_20%,rgba(168,85,247,0.08),transparent_20%)]" />

      {/* Blobs */}
      <div className="absolute top-[-100px] right-[-80px] w-[220px] h-[220px] bg-purple-300/20 rounded-full blur-3xl" />
      <div className="absolute bottom-[-100px] left-[-80px] w-[240px] h-[240px] bg-indigo-300/20 rounded-full blur-3xl" />

      {/* Subtle grid texture */}
      <div className="absolute inset-0 opacity-[0.03] [background-image:linear-gradient(to_right,#0f172a_1px,transparent_1px),linear-gradient(to_bottom,#0f172a_1px,transparent_1px)] [background-size:32px_32px]" />

      <div className="relative max-w-6xl mx-auto px-4 pt-16 pb-8">
        {/* Top divider */}
        <div className="h-px w-full mb-12 bg-gradient-to-r from-transparent via-slate-300 to-transparent" />

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8"
        >
          {/* Brand */}
          <div className="md:col-span-2">
          <img
              src="/logo.png"
              alt="A2Z Consultancy Logo"
              className="h-20 md:h-24 w-auto mb-4 object-contain"
            />

            <p className="text-gray-600 text-sm md:text-base leading-relaxed max-w-md">
              Connecting families with trusted home help while helping
              professionals find reliable work opportunities — built on safety,
              trust, and ease.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4 tracking-wide uppercase">
              Contact
            </h4>

            <div className="space-y-4 text-sm text-gray-600">
              {/* Phone */}
              <div className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-indigo-600 mt-0.5" />
                <span>+91 919665855163</span>
              </div>

              {/* Email */}
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-indigo-600 mt-0.5" />
                <span>a2zconsultancyy@gmail.com</span>
              </div>

              {/* Address */}
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-indigo-600 mt-0.5" />
                <span>
                  Shop No 105, Rajyog Elanza
                  <br />
                  Palghar(W) - 401404
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Bottom */}
        <div className="mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 border-t border-slate-200 text-sm text-gray-500">
          <span>
            © {new Date().getFullYear()} A2Z Consultancy. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;